import { render } from "./EnemigosSwitcher.vue?vue&type=template&id=a4f383a8"
import script from "./EnemigosSwitcher.vue?vue&type=script&lang=js"
export * from "./EnemigosSwitcher.vue?vue&type=script&lang=js"

import "./EnemigosSwitcher.vue?vue&type=style&index=0&id=a4f383a8&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__